var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4323 1.56555C13.6457 1.35219 13.899 1.18295 14.1777 1.06748C14.4565 0.952009 14.7553 0.892578 15.057 0.892578C15.3587 0.892578 15.6575 0.952009 15.9363 1.06748C16.2151 1.18295 16.4684 1.35219 16.6817 1.56555C16.8951 1.77891 17.0643 2.0322 17.1798 2.31097C17.2953 2.58974 17.3547 2.88852 17.3547 3.19025C17.3547 3.49198 17.2953 3.79076 17.1798 4.06953C17.0643 4.3483 16.8951 4.60159 16.6817 4.81495L5.71499 15.7817L1.24707 17.0002L2.46559 12.5323L13.4323 1.56555Z",
    strokeWidth: 1.6247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.13617fec730d38b9020e3cef7768dc1b.svg";
export { ForwardRef as ReactComponent };